export default {
  /**
   * 生成指定范围的随机整数
   * @param {Number} min 最小值
   * @param {Number} max 最大值
   */
  zzwRangeRandom: function (min, max) {
    if (min === null || min === undefined || isNaN(min)) {
      throw new Error('min must be a number');
    }
    if (max === null || max === undefined || isNaN(max)) {
      throw new Error('max must be a number');
    }
    return Math.floor(Math.random() * (max - min + 1) + min);
  }
}



// WEBPACK FOOTER //
// ./src/utils/extensions/Math.js